import React, { useState, useEffect } from 'react';
import Dashboard from '../Dashboard/Dashboard';
import axios from 'axios';
import './InfoContact.css';
import { Helmet } from 'react-helmet';
import { END_URL, IMG_URL } from "../../config.js";



function InfoContact() {

    const [formData, setFormData] = useState({});

    const [validationErrors, setValidationErrors] = useState({});
    const [modalMessage, setModalMessage] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [countries, setCountries] = useState([]);

    const [Contact, setContact] = useState([]);

    const [ContactInfo, setContactInfo] = useState([]);

    const [seo, setSeo] = useState({});

    // const handleChange = (e) => {
    //     setFormData({ ...formData, [e.target.id]: e.target.value });
    //     setValidationErrors({ ...validationErrors, [e.target.id]: '' });
    // };

    const handleChange = (e) => {

        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));

        setValidationErrors(prev => ({
            ...prev,
            [e.target.name]: ''
        }));
    };

    const validateForm = () => {
        const errors = {};
        Contact?.fields?.forEach(field => {

            const fieldName = `field_${field.id}`;
            const value = formData[fieldName] || '';

            if (field.required && !value.trim()) {

                errors[fieldName] = `${field.label} is required`;
            }

            if (
                field.field_type === 'email' &&
                value
            ) {

                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                if (!emailRegex.test(value)) {

                    errors[fieldName] = 'Invalid email address';
                }
            }
        });

        setValidationErrors(errors);

        return Object.keys(errors).length === 0;
    };


    useEffect(() => {
        const GetContactDetail = async () => {
            try {
                const response = await axios.get(`${END_URL}/contact-info`);

                setContact(response?.data?.contact_detail?.contact_detail);

                setContactInfo(response?.data?.contact_detail?.contact_info);
                
                const fields = response?.data?.contact_detail?.contact_detail?.fields || [];

                const initialData = {};

                fields.forEach(field => {
                    initialData[`field_${field.id}`] = '';
                });

                initialData['contact_page_id'] = Contact?.id;

                setFormData(initialData);

                setSeo(response.data.seo_page);

            } catch (error) {
                   console.error('There was an error submitting the form:', error);

                if (error.response?.status === 422) {

                    const serverErrors = {};

                    Object.keys(error.response.data.errors).forEach(key => {

                        serverErrors[key] =
                            error.response.data.errors[key][0];

                    });

                    setValidationErrors(serverErrors);

                    return;
                }

                setModalMessage(false);
                setModalVisible(true);
            }
        };

        GetContactDetail();
    }, []);

    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const response = await axios.get(`${END_URL}/countries`);

                if (
                    response.data &&
                    response.data.countries &&
                    Array.isArray(response.data.countries)
                ) {
                    const countryNames = response.data.countries
                        .map((country_id) => country_id.name.common)
                        .sort((a, b) => a.localeCompare(b));

                    setCountries(response.data.countries);
                } else {
                    console.error("Data is not in the expected format:", response.data);

                    setCountries([]);
                }
            } catch (error) {
                console.error("Failed to fetch countries:", error);
            }
        };

        fetchCountries();
    }, []);


    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        try {
            const response = await axios.post(`${END_URL}/contact-info-submit`, formData);

            setModalMessage(true);

            setModalVisible(true);

            const resetData = {};

            Contact?.fields?.forEach(field => {
                resetData[`field_${field.id}`] = '';
            });

            resetData['contact_page_id'] = Contact?.id;

            setFormData(resetData);

            setValidationErrors({});
        } catch (error) {
            console.error('There was an error submitting the form:', error);
            setModalMessage(false);
            setModalVisible(true);
        }
    };

    return (
        <>

        <Helmet>
            <title>
                {seo?.meta_title ||
                "PersonalityTest - Discover Your True Archetype | Personality Peek"}
            </title>
    
            <meta
                name="description"
                content={
                seo?.meta_description ||
                "Take the Personality Test at Personality Peek. Discover your true archetype, unlock insights and start your self-discovery journey."
                }
            />
    
            <meta
                name="keywords"
                content={
                seo?.meta_keywords ||
                "personality assessment test , personality test"
                }
            />
    
            {seo?.og_title && <meta property="og:title" content={seo.og_title} />}
            {seo?.og_description && (
                <meta property="og:description" content={seo.og_description} />
            )}
            {seo?.og_image && (
                <meta property="og:image" content={`${IMG_URL}/d0/${seo.og_image}`} />
            )}
            {seo?.og_url && <meta property="og:url" content={seo.og_url} />}
            {seo?.og_type && <meta property="og:type" content={seo.og_type} />}
    
            {seo?.twitter_title && (
                <meta name="twitter:title" content={seo.twitter_title} />
            )}
            {seo?.twitter_description && (
                <meta name="twitter:description" content={seo.twitter_description} />
            )}
            {seo?.twitter_image && (
                <meta
                name="twitter:image"
                content={`${IMG_URL}/d0/${seo.twitter_image}`}
                />
            )}
            {seo?.twitter_card && (
                <meta name="twitter:card" content={seo.twitter_card} />
            )}
    
            {seo?.og_url && <link rel="canonical" href={seo.og_url} />}
    
            {!seo?.og_title && (
                <meta
                property="og:title"
                content="PersonalityTest - Discover Your True Archetype | Personality Peek"
                />
            )}
            {!seo?.og_description && (
                <meta
                property="og:description"
                content="Take the Personality Test at Personality Peek. Discover your true archetype, unlock insights and start your self-discovery journey."
                />
            )}
            {!seo?.og_type && <meta property="og:type" content="website" />}
            {!seo?.twitter_card && (
                <meta name="twitter:card" content="summary_large_image" />
            )}

        </Helmet>


            <div>
                <div className='result-cont contact-page'>
                    <div className="container-fluid">
                        <div className="row">

                            <div className="col-12 col-sm-12 col-md-9 col-lg-9">

                                <div className="contact-form-info">

                                    <span className='contact-header' dangerouslySetInnerHTML={{ __html: Contact?.page_title }} />

                                    <form onSubmit={handleSubmit} noValidate>

                                      {(() => {

                                            const rows = [];
                                            let currentRow = [];

                                            Contact?.fields?.forEach((field, index) => {

                                                const fieldName = `field_${field.id}`;

                                                const fieldHtml = (
                                                    <div
                                                        key={field.id}
                                                        className="form-group col-md-6"
                                                    >
                                                        <label>

                                                            {field.label}

                                                            {field.required == 1 && (
                                                                <span style={{ color: 'red' }}> *</span>
                                                            )}

                                                        </label>

                                                        {field.field_type === 'text' && (
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name={fieldName}
                                                                value={formData[fieldName] || ''}
                                                                onChange={handleChange}
                                                            />
                                                        )}

                                                        {field.field_type === 'email' && (
                                                            <input
                                                                type="email"
                                                                className="form-control"
                                                                name={fieldName}
                                                                value={formData[fieldName] || ''}
                                                                onChange={handleChange}
                                                            />
                                                        )}

                                                        {field.field_type === 'country' && (
                                                            <select
                                                                className="form-control"
                                                                name={fieldName}
                                                                value={formData[fieldName] || ''}
                                                                onChange={handleChange}
                                                            >
                                                                <option value="">
                                                                    Select Country
                                                                </option>

                                                                {countries.map((country) => (
                                                                    <option
                                                                        key={country.id}
                                                                        value={country.name}
                                                                    >
                                                                        {country.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        )}

                                                        {validationErrors[fieldName] && (
                                                            <small className="text-danger">
                                                                {validationErrors[fieldName]}
                                                            </small>
                                                        )}
                                                    </div>
                                                );

                                                if (field.field_type === 'textarea') {

                                                    if (currentRow.length > 0) {

                                                        rows.push(
                                                            <div
                                                                className="form-row"
                                                                key={`row-${index}`}
                                                            >
                                                                {currentRow}
                                                            </div>
                                                        );

                                                        currentRow = [];
                                                    }

                                                    rows.push(
                                                        <div
                                                            className="form-group"
                                                            key={field.id}
                                                        >
                                                            <label>

                                                                {field.label}

                                                                {field.required == 1 && (
                                                                    <span style={{ color: 'red' }}> *</span>
                                                                )}

                                                            </label>

                                                            <textarea
                                                                className="form-control"
                                                                rows="5"
                                                                name={fieldName}
                                                                value={formData[fieldName] || ''}
                                                                onChange={handleChange}
                                                            />

                                                            {validationErrors[fieldName] && (
                                                                <small className="text-danger">
                                                                    {validationErrors[fieldName]}
                                                                </small>
                                                            )}
                                                        </div>
                                                    );

                                                    return;
                                                }

                                                currentRow.push(fieldHtml);

                                                if (currentRow.length === 2) {

                                                    rows.push(
                                                        <div
                                                            className="form-row"
                                                            key={`row-${index}`}
                                                        >
                                                            {currentRow}
                                                        </div>
                                                    );

                                                    currentRow = [];
                                                }
                                            });

                                            if (currentRow.length > 0) {

                                                rows.push(
                                                    <div
                                                        className="form-row"
                                                        key="last-row"
                                                    >
                                                        {currentRow}
                                                    </div>
                                                );
                                            }

                                            return rows;

                                        })()}

                                        <button type="submit" className="btn btn-primary">Submit</button>
                                    </form>

                                    <div class="contact-section">

                                        <span className='contact-footer' dangerouslySetInnerHTML={{ __html: Contact?.footer_content }} />
                                        
                                        {ContactInfo && (ContactInfo?.info_contact_email_show || ContactInfo?.info_contact_phone) && (

                                            <div className="contact-detail-info">

                                                {ContactInfo?.info_contact_email_show && (

                                                    <div>
                                                        <span>Email</span>
                                                        <a href={`mailto:${ContactInfo?.info_contact_email_show}`} >{ContactInfo?.info_contact_email_show}</a>
                                                    </div>
                                                )}

                                            {ContactInfo?.info_contact_phone && (
                                                    <div>
                                                        <span>Phone</span>
                                                        {(() => {
                                                        const cleanedPhone = ContactInfo.info_contact_phone
                                                            ?.trim()                      
                                                            ?.replace(/[^\d]/g, "");   

                                                        return cleanedPhone ? (
                                                            <a href={`tel:${cleanedPhone}`}>{ContactInfo.info_contact_phone}</a>
                                                        ) : (
                                                            <span></span>
                                                        );
                                                        })()}
                                                    </div>
                                                )}


                                            </div>

                                        )}

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {modalVisible && (
                    <div className="modal fade show contact-modal" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content contact-modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{ContactInfo?.info_contact_email_title}</h5>
                                    <button type="button" className="close" onClick={() => setModalVisible(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>

                                    {ContactInfo?.info_contact_email_content && (

                                        <div className="modal-body" dangerouslySetInnerHTML={{ __html:ContactInfo?.info_contact_email_content }}/>
                                    )}
                                
                            </div>
                        </div>
                    </div>
                )}
            </div>

        </>

    );
}

export default InfoContact;
